import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Billets Yard",
      children: [
        {
          field: "Molds",
          headerName: "Section",
          flex: 1,
        },
        {
          field: "Length",
          headerName: "Length",
          flex: 1,
        },
        {
          field: "Quality",
          headerName: "Quality",
          flex: 1,
          valueGetter: (params) => {
            return params.data.Quality === "G"
              ? "Good"
              : params.data.Quality === "U"
                ? "Unidentified"
                : params.data.Quality === "S"
                  ? "Scrapped"
                  : "";
          },
        },
        {
          field: "BilletCount",
          headerName: "Billets Count",
          flex: 1,
        },
      ],
    },
  ];

  return { columns };
};
